import BaseObject from "@shared/BaseObject.js";

export default class CanvasGuidanceManager extends BaseObject {
	constructor({notifyStateChanged, canShowOnboarding, storageKey, stepId, desktopMessage, touchMessage, initialDelayMs = 450} = {}) {
		super()
		this.notifyStateChanged = notifyStateChanged || (() => {})
		this.canShowOnboarding = canShowOnboarding || (() => true)
		this.storageKey = storageKey || "canvasGuidanceCompletedSteps"
		this.stepId = stepId || "dragAddFromLeftToCanvas"
		this.desktopMessage = desktopMessage || "Drag an item from the left onto the canvas to add it."
		this.touchMessage = touchMessage || "Tap an item on the left to add it."
		this.initialDelayMs = Math.max(0, Number(initialDelayMs) || 0)
		this.completedStepIds = this.loadCompletedStepIds()
		this.activeStepId = ""
		this.delayedOnboardingTimeoutId = null
	}

	start() {
		this.clearDelayedOnboardingTimeout()
		this.notifyStateChanged({isVisible: false, message: "", stepId: "", placement: "bottom-center"})
		this.delayedOnboardingTimeoutId = setTimeout(() => {
			this.delayedOnboardingTimeoutId = null
			this.syncState()
		}, this.initialDelayMs)
	}

	destroy() {this.clearDelayedOnboardingTimeout()}

	handleDragAddCompleted() {
		this.clearDelayedOnboardingTimeout()
		this.completeStep(this.stepId)
	}

	syncState() {
		const step = this.getActiveStep()
		this.activeStepId = step?.id || ""
		this.notifyStateChanged({isVisible: !!step, message: step?.message || "", stepId: this.activeStepId, placement: step?.placement || "bottom-center"})
	}

	getActiveStep() {return this.canShowOnboarding() ? this.getDragAddStep() : null}

	getDragAddStep() {
		if (this.isStepCompleted(this.stepId)) return null
		return {id: this.stepId, message: this.isTapDevice() ? this.touchMessage : this.desktopMessage, placement: "bottom-center"}
	}

	isTapDevice() {return typeof window !== "undefined" && window.matchMedia?.("(pointer: coarse)").matches === true}

	completeStep(stepId) {
		if (!stepId || this.isStepCompleted(stepId)) return
		this.completedStepIds.push(stepId)
		this.persistCompletedStepIds()
		this.syncState()
	}

	isStepCompleted(stepId) {return this.completedStepIds.includes(stepId)}

	loadCompletedStepIds() {
		try {
			const value = typeof window !== "undefined" ? window.localStorage?.getItem(this.storageKey) : null
			const parsed = JSON.parse(value || "[]")
			return Array.isArray(parsed) ? parsed.filter(item => typeof item === "string" && item) : []
		} catch (error) {
			console.warn("CanvasGuidanceManager.loadCompletedStepIds failed", error)
			return []
		}
	}

	persistCompletedStepIds() {
		try {
			if (typeof window !== "undefined") window.localStorage?.setItem(this.storageKey, JSON.stringify(this.completedStepIds))
		} catch (error) {
			console.warn("CanvasGuidanceManager.persistCompletedStepIds failed", error)
		}
	}

	clearDelayedOnboardingTimeout() {
		if (!this.delayedOnboardingTimeoutId) return
		clearTimeout(this.delayedOnboardingTimeoutId)
		this.delayedOnboardingTimeoutId = null
	}
}
